import { QueryClientProvider, QueryClient, setLogger } from 'react-query';
import { getLogger } from '~/utils/logger';
import type { JSX } from 'react';

interface InfrastructureProps {
  children: JSX.Element;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryOnMount: false,
      retry: Number(process.env.INFRASTRUCTURE_RETRIES) || false,
    },
  },
});

setLogger({
  error: (error: any) => {
    getLogger().error(`[InfrastructureProvider] - ${error?.message}`, error);
  },
  log: () => {},
  warn: () => {},
});

export const InfrastructureProvider = ({ children }: InfrastructureProps): JSX.Element => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
